<template>
  <div class="cr-main-page">
    <Slider></Slider>
    <div class="cr-main-page__middle">
      <Numproducts></Numproducts>
      <ProductSlider type="new" title="Новинки"></ProductSlider>
      <ProductSlider type="sale" title="Акции"></ProductSlider>
    </div>
    <Main></Main>
  </div>
</template>

<script>
import Slider from "@/views/components/Slider.vue";
import Numproducts from "@/views/components/Numproducts.vue";
import ProductSlider from "@/views/components/ProductSlider.vue";
import Main from "@/views/components/Main.vue";
import {mapActions} from "vuex";
export default {
    data: () => ({

    }),
  components: {
      Slider,
    Numproducts,
    ProductSlider,
    Main
  }
}
</script>
